/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Heading_1Inputs */

const et_pricing_heading_1 = /** @type {(inputs: Pricing_Heading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saage`)
};

const en_pricing_heading_1 = /** @type {(inputs: Pricing_Heading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get`)
};

/**
* | output |
* | --- |
* | "Get" |
*
* @param {Pricing_Heading_1Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const pricing_heading_1 = /** @type {((inputs?: Pricing_Heading_1Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Heading_1Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_pricing_heading_1(inputs)
	return en_pricing_heading_1(inputs)
});